import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b057f6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row py-4 d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5 py-4" }, [
  /*#__PURE__*/_createElementVNode("h2", {
    class: "m-0 p-0",
    style: {"color":"var(--cor_texto_1)"}
  }, "Lista de Consultores")
], -1))
const _hoisted_3 = { class: "col-lg-7 d-flex align-items-center justify-content-end gap-5 flex-wrap" }
const _hoisted_4 = {
  id: "competitors-input-filter",
  class: "w-100 w-md-auto"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  disabled: "",
  class: "btn btn_background_1 d-md-flex align-items-center justify-content-center"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Adicionar", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-4" }, "Adicionar", -1))
const _hoisted_15 = {
  key: 0,
  id: "box-table-competitors",
  class: "background_1 card"
}
const _hoisted_16 = { style: {"opacity":"0.5"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-store-alt",
  "aria-hidden": "true",
  style: {"color":"white","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pencil-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0"}
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ps-4" }, "Recuperar", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_303_15)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.3",
      d: "M50 56.25C65.5273 56.25 78.125 43.6523 78.125 28.125C78.125 12.5977 65.5273 0 50 0C34.4727 0 21.875 12.5977 21.875 28.125C21.875 43.6523 34.4727 56.25 50 56.25ZM75 62.5H64.2383C59.9023 64.4922 55.0781 65.625 50 65.625C44.9219 65.625 40.1172 64.4922 35.7617 62.5H25C11.1914 62.5 0 73.6914 0 87.5V90.625C0 95.8008 4.19922 100 9.375 100H90.625C95.8008 100 100 95.8008 100 90.625V87.5C100 73.6914 88.8086 62.5 75 62.5Z",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M75 62.5H64.2383C59.9023 64.4922 55.0781 65.625 50 65.625C44.9219 65.625 40.1172 64.4922 35.7617 62.5H25C11.1914 62.5 0 73.6914 0 87.5V90.625C0 95.8008 4.19922 100 9.375 100H90.625C95.8008 100 100 95.8008 100 90.625V87.5C100 73.6914 88.8086 62.5 75 62.5Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_303_15" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "100",
        height: "100",
        fill: "white"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampModalDelRegister = _resolveComponent("CampModalDelRegister")!
  const _component_CampModalRecoverRegister = _resolveComponent("CampModalRecoverRegister")!
  const _component_modalRelationStore = _resolveComponent("modalRelationStore")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.keywordSearch,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
            placeholder: "Busque por algum Consultor",
            type: "text",
            disabled: _ctx.isLoading
          }, null, 8, ["modelValue", "disabled"]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_switch, {
            id: "form-training-post-active",
            modelValue: _ctx.activeStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeStatus) = $event)),
            style: {"--el-switch-on-color":"var(--el-color-primary)"}
          }, null, 8, ["modelValue"]),
          (_ctx.activeStatus)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Ativos"))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "Inativos"))
        ]),
        _createElementVNode("div", null, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("button", _hoisted_9, _hoisted_12))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: `/consultor/cadastrar`,
                class: "btn btn_background_1 d-md-flex align-items-center justify-content-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _hoisted_14
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    (!_ctx.isLoading && _ctx.printCompetitors?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.printCompetitors)
            ? (_openBlock(), _createBlock(_component_CampTable, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createVNode(_component_CampTableTh, null, {
                        default: _withCtx(() => [
                          _createTextVNode("CPF")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CampTableTh, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Nome")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CampTableTh, null, {
                        default: _withCtx(() => [
                          _createTextVNode("E-mail")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CampTableTh, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Telefone")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CampTableTh, { style: {"width":"15rem"} }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ações")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printCompetitors, (competitor) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createVNode(_component_CampTableTd, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(competitor.cpf), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(competitor.name) + " ", 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(competitor.role == 6? " - Moderador" : ""), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(competitor.email || 'Não informado'), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(competitor.tel), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_CampTableTd, { class: "gap-4 d-flex py-2" }, {
                          default: _withCtx(() => [
                            (!competitor.deleted_at)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm background_btn_1",
                                    onClick: ($event: any) => (_ctx.funcDetailRelationData(competitor)),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#myModalDetailRelationData"
                                  }, _hoisted_19, 8, _hoisted_17),
                                  _createVNode(_component_router_link, {
                                    to: `/consultor/atualizar/${competitor.id}`,
                                    class: "btn btn-sm background_btn_1_opct"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_20
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.handleModalDelRegister(competitor)),
                                    class: "btn btn-sm background_btn_1_opct"
                                  }, _hoisted_23, 8, _hoisted_21)
                                ], 64))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (_ctx.handleModalRecoverRegister(competitor)),
                                  class: "btn btn-sm background_btn_1_opct w-100"
                                }, _hoisted_27, 8, _hoisted_24))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 256))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.printCompetitors?.length)
      ? (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
          key: 2,
          id: "competitors-icon-empty-list-feedback"
        }, {
          icon: _withCtx(() => [
            _hoisted_28
          ]),
          message: _withCtx(() => [
            _createTextVNode("Não há nada para mostrar")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_CampModalDelRegister, {
      header: "Excluir Consultor!",
      message: "",
      toggle: _ctx.toggleModalDelRegister,
      name: _ctx.tableItem?.name || '',
      handleButtonClick: () => _ctx.handleConfirmItemDel()
    }, null, 8, ["toggle", "name", "handleButtonClick"]),
    _createVNode(_component_CampModalRecoverRegister, {
      header: "Recuperar Consultor!",
      message: "",
      toggle: _ctx.toggleModalRecoverRegister,
      name: _ctx.tableItem?.name || '',
      handleButtonClick: () => _ctx.handleConfirmItemRecover()
    }, null, 8, ["toggle", "name", "handleButtonClick"]),
    _createVNode(_component_modalRelationStore, {
      "relation-data": (_ctx.relationData as any),
      "is-change-props": (_ctx.relationProps as any)
    }, null, 8, ["relation-data", "is-change-props"])
  ]))
}